import { render, staticRenderFns } from "./AppUnreadBerichtenBadgeComponent.vue?vue&type=template&id=27110f90&scoped=true&"
import script from "./AppUnreadBerichtenBadgeComponent.ts?vue&type=script&lang=ts&"
export * from "./AppUnreadBerichtenBadgeComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppUnreadBerichtenBadgeComponent.scss?vue&type=style&index=0&id=27110f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27110f90",
  null
  
)

export default component.exports